import { Locale } from '../../domain/entities/locale';
import { LocaleResolutionResult } from '../../domain/entities/locale-resolution-policy';
import {
    resolveUrlOnlyLocaleTarget,
    UrlOnlyLocaleTarget,
} from '../../domain/services/url-only-locale-target';

/**
 * Politica UrlOnly (rutas /t y /u): el idioma lo decide unicamente la URL (ver
 * resolveUrlOnlyLocaleTarget). Pura: no lee ni escribe storage ni estado.
 */
export class UrlOnlyLocaleStrategy {
    public resolve(url: string): LocaleResolutionResult {
        const suffixIndex: number = url.search(/[?#]/);
        const pathname: string = suffixIndex >= 0 ? url.slice(0, suffixIndex) : url;
        const suffix: string = suffixIndex >= 0 ? url.slice(suffixIndex) : '';
        const target: UrlOnlyLocaleTarget = resolveUrlOnlyLocaleTarget(
            pathname.split('/').filter(Boolean),
        );

        return {
            locale: Locale.fromLanguage(target.language),
            redirectTo: target.redirectPath === null ? null : `${target.redirectPath}${suffix}`,
            notFound: target.notFound,
        };
    }
}
